import { Button } from '@finam/web-ui-kit';
import React, { useState } from 'react';
import { WebService } from '../../Services/WebService';
import { TokenContext } from '../../TokenContext';
import './SMSCodePanel.scss';

interface IProps {
    docIds: number[],
    confirmId: string,
    message: string,
    afterAction: () => void
}


export const SMSCodePanel: React.FC<IProps> = (props) => {

    const [smscode, setSMSCode] = useState('');
    const [isLoading, setIsLoading] = useState(false);

    function SendCode(token: string, code: string) {
        setIsLoading(true);
        new WebService(token).SendCodeUNEPDocuments({ code: code, confirmId: props.confirmId, docIds: props.docIds })
            .then(res => { setIsLoading(false); props.afterAction(); setSMSCode(''); })
    }

    return (<TokenContext.Consumer>{value => <div className='sms-panel__wrapper'>
        <div>{props.message}</div>
        <div className='sms-panel__codePanel'>
            <input onChange={val => { setSMSCode(val.target.value) }} value={smscode}></input>
            <Button
                disabled={isLoading}
                loading={isLoading}
                onClick={() => { SendCode(value.token, smscode); }}
            >Отправить код</Button>
        </div>
    </div>}</TokenContext.Consumer>);
}